import {createContext} from "react";
import {initialGroupObj} from "./Group"
import {IGroup} from "../../interfaces/IGroup";

export const GroupContext = createContext({
    group: initialGroupObj,
    setGroup: (group:IGroup) => {}
})

